import {Box} from "@mui/material";
import * as React from "react";
import {styled} from "@mui/material/styles";

export const BlueDot = styled(Box)(({theme}) => ({
    width: "15px",
    height: "15px",
    borderRadius: "50%",
    backgroundColor: theme.palette.info.main
}));